import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FounderStory = () => {
  const milestones = [
    {
      year: "2021",
      title: "The Beginning",
      description: "Started as a freelance designer with a vision to bridge the gap between creativity and technology.",
      icon: "Lightbulb"
    },
    {
      year: "2021",
      title: "First Team Member",
      description: "Expanded to include development expertise, marking the transition from solo work to collaborative excellence.",
      icon: "Users"
    },
    {
      year: "2021",
      title: "Digital Transformation Focus",
      description: "Pivoted to comprehensive digital solutions, helping businesses navigate the post-pandemic digital landscape.",
      icon: "TrendingUp"
    },
    {
      year: "2022",
      title: "Industry Recognition",
      description: "Received multiple awards for innovative web design and development, establishing credibility in the market.",
      icon: "Award"
    },
    {
      year: "2022",
      title: "Full-Service Agency",
      description: "Evolved into a complete digital transformation partner with expertise across all digital touchpoints.",
      icon: "Rocket"
    },
    {
      year: "2022",
      title: "Innovation Lab",
      description: "Launched experimental projects division, exploring AI integration and emerging technologies.",
      icon: "Zap"
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="User" size={24} className="text-white" />
            </div>
            <span className="text-primary font-semibold text-lg">Founder's Journey</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            From Vision to Reality
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            The story of Singh Creations is one of passion, persistence, and the relentless pursuit of digital excellence.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start mb-20">
          {/* Founder Profile */}
          <div className="relative">
            <div className="bg-white rounded-2xl p-8 brand-shadow">
              <div className="flex items-start space-x-6">
                <div className="relative">
                  <Image
                    src="https://cdn-icons-png.flaticon.com/512/9193/9193919.png"
                    alt="Jasmeet Singh - Founder & Creative Director"
                    className="w-24 h-24 rounded-full object-cover"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-accent rounded-full flex items-center justify-center">
                    <Icon name="Crown" size={16} className="text-white" />
                  </div>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-foreground mb-2">Jasmeet Singh</h3>
                  {/* <p className="text-accent font-semibold mb-3">Founder & Creative Director | Digital Strategist & Full-Stack Flutter/Web Developer</p> */}
                  <p className="text-accent font-semibold mb-1">
  Founder & Creative Director
</p>
<p className="text-accent font-semibold mb-3">
  Digital Strategist & Full-Stack Developer
</p>

                  <p className="text-muted-foreground mb-4">
                    "I believe that great digital experiences happen when creative vision meets technical precision. Every project is an opportunity to create something meaningful."
                  </p>
                  
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full">UI/UX Design 🎨</span>
                    <span className="px-3 py-1 bg-accent/10 text-accent text-sm rounded-full">Flutter Developerment (iOS & Android) 📱</span>
                     <span className="px-3 py-1 bg-accent/10 text-accent text-sm rounded-full">Web Development 💻</span>
                    <span className="px-3 py-1 bg-success/10 text-success text-sm rounded-full">Digital Strategy & Transformation 🚀</span>
                     <span className="px-3 py-1 bg-success/10 text-success text-sm rounded-full">Social Media Marketing (SMO & SMM) 📢</span>

                    
                  </div>
                </div>
              </div>
              
              <div className="mt-8 pt-8 border-t border-border">
                <div className="grid grid-cols-3 gap-6 text-center">
                  <div>
                    <div className="text-2xl font-bold text-primary">2+</div>
                    <div className="text-sm text-muted-foreground">Years Experience</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-accent">50+</div>
                    <div className="text-sm text-muted-foreground">Projects Led</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-success">2+</div>
                    <div className="text-sm text-muted-foreground">Global Clients</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Philosophy */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 brand-shadow">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Heart" size={24} className="text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3">Our Philosophy</h3>
                  <p className="text-muted-foreground">
                    We don't just deliver services; we architect digital transformations that elevate brands and create meaningful connections between businesses and their audiences.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 brand-shadow">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Target" size={24} className="text-accent" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3">Our Mission</h3>
                  <p className="text-muted-foreground">
                    To turn digital complexity into elegant simplicity, empowering businesses to thrive in the digital age through innovative solutions and strategic partnerships.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 brand-shadow">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="Eye" size={24} className="text-success" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-3">Our Vision</h3>
                  <p className="text-muted-foreground">
                    To be the trusted digital transformation partner for ambitious businesses, known for our unique blend of creative excellence and technical mastery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-border"></div>


          
          <div className="space-y-12">
            {milestones?.map((milestone, index) => (
              <div key={milestone?.year} className={`flex items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div className="bg-white rounded-2xl p-6 brand-shadow">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                        <Icon name={milestone?.icon} size={24} className="text-white" />
                      </div>
                      <div className="flex-1">
                        <div className="text-sm font-semibold text-accent mb-1">{milestone?.year}</div>
                        <h3 className="text-xl font-bold text-foreground mb-2">{milestone?.title}</h3>
                        <p className="text-muted-foreground">{milestone?.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-4 h-4 bg-accent rounded-full border-4 border-white brand-shadow"></div>
                </div>
                
                <div className="hidden lg:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;